import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import Learning from "./pages/new-design/Learning";
import Activities from "./pages/new-design/Activities";
import AddLearning from "./pages/AddLearning";
import AddBenefit from "./pages/AddBenefit";
import AddActivity from "./pages/AddActivity";
import AddQuiz from "./pages/AddQuiz";
import SingleQuiz from "./pages/SingleQuiz";
import Login from "./pages/Login";
import Advocacy from "./pages/new-design/Advocacy";
import UserActivitiesProof from "./pages/UserActivitiesProof";
import RewardUser from "./pages/RewardUser";
import Reward from "./pages/Reward";
import WithdrawalRequests from "./pages/WithdrawalRequests";
import QuizResults from "./pages/QuizResults";
import Notification from "./pages/new-design/Notification";
import Rewards from "./pages/new-design/Rewards";
import Users from "./pages/new-design/Users";
import Analytics from "./pages/new-design/Analytics";
import Quizzes from "./pages/new-design/Quizzes";
import Benefits from "./pages/new-design/Benefits";
import Withdrawals from "./pages/new-design/Withdrawals";
import { isAuthed } from "./utils/auth";

function RequireAdmin({ children }) {
  if (!isAuthed()) {
    return <Navigate to="/" replace />;
  }
  return children;
}

function App() {
  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route
            path="/home"
            element={
              <RequireAdmin>
                <Analytics />
              </RequireAdmin>
            }
          />
          <Route
            path="/users"
            element={
              <RequireAdmin>
                <Users />
              </RequireAdmin>
            }
          />
          <Route
            path="/rewards"
            element={
              <RequireAdmin>
                <Rewards />
              </RequireAdmin>
            }
          />
          <Route
            path="/withdrawal"
            element={
              <RequireAdmin>
                <Withdrawals />
              </RequireAdmin>
            }
          />
          <Route
            path="/notification"
            element={
              <RequireAdmin>
                <Notification />
              </RequireAdmin>
            }
          />
          <Route
            path="/quiz"
            element={
              <RequireAdmin>
                <Quizzes />
              </RequireAdmin>
            }
          />
          <Route
            path="/quiz/add-quiz"
            element={
              <RequireAdmin>
                <AddQuiz />
              </RequireAdmin>
            }
          />
          <Route
            path="/quiz/:id"
            element={
              <RequireAdmin>
                <SingleQuiz />
              </RequireAdmin>
            }
          />
          <Route
            path="/quiz/quiz-results"
            element={
              <RequireAdmin>
                <QuizResults />
              </RequireAdmin>
            }
          />
          <Route
            path="/learning"
            element={
              <RequireAdmin>
                <Learning />
              </RequireAdmin>
            }
          />
          <Route
            path="/learning/add-learning"
            element={
              <RequireAdmin>
                <AddLearning />
              </RequireAdmin>
            }
          />
          <Route
            path="/activity"
            element={
              <RequireAdmin>
                <Activities />
              </RequireAdmin>
            }
          />
          <Route
            path="/activities/add-activities"
            element={
              <RequireAdmin>
                <AddActivity />
              </RequireAdmin>
            }
          />
          <Route
            path="/activities/user-activities-proof"
            element={
              <RequireAdmin>
                <UserActivitiesProof />
              </RequireAdmin>
            }
          />
          <Route
            path="/benefit"
            element={
              <RequireAdmin>
                <Benefits />
              </RequireAdmin>
            }
          />
          <Route
            path="/benefit/add-benefit"
            element={
              <RequireAdmin>
                <AddBenefit />
              </RequireAdmin>
            }
          />
          <Route
            path="/benefit/reward-user"
            element={
              <RequireAdmin>
                <RewardUser />
              </RequireAdmin>
            }
          />
          <Route
            path="/benefit/rewards"
            element={
              <RequireAdmin>
                <Rewards />
              </RequireAdmin>
            }
          />
          <Route
            path="/benefit/withdrawal-requests"
            element={
              <RequireAdmin>
                <WithdrawalRequests />
              </RequireAdmin>
            }
          />
          <Route
            path="/advocacy"
            element={
              <RequireAdmin>
                <Advocacy />
              </RequireAdmin>
            }
          />
          <Route
            path="/reward/:user"
            element={
              <RequireAdmin>
                <Reward />
              </RequireAdmin>
            }
          />
          <Route exact path="/" element={<Login />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
